export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  panelHeader: {
    marginTop: 15,
    fontSize: "1rem",
    fontWeight: 600,
    marginBottom: "1rem",
  },
  c: {
    marginLeft: "15px",
    marginRight: 0,
  },
  inputLabel: {
    color: "rgba(0, 0, 0)",
    paddingBottom: 10,
    fontWeight: 600,
  },
  switchBase: {
    color: "#52d869",
    "&$checked": {
      color: "#52d869",
    },
    "&$checked + $track": {
      backgroundColor: "#52d869",
    },
  },
  checked: {},
  track: {},
  inputField: {
    height: 40,
    marginTop: 0,
  },

  centerAll: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dropZone: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 3,
    width: "100%",
  },
  dropZoneInner: {
    width: "100%",
    height: 35,
    border: "2px dotted grey",
    borderRadius: 5,
    backgroundColor: "#f5f5f5",
    padding: "10px 20px",
    marginBottom: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
});
